import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangProvider";
import { useWords } from "../hooks";

const Footer = () => {
  const [lang] = useLang();
  const langWords = useWords(lang);
  return (
    <footer className="overflow-hidden relative mt-28">
      <div
        style={{
          height: "230vw",
          width: "230vw",
        }}
        className="rounded-full bg-primary absolute left-1/2 transform -translate-x-1/2 top-0"
      ></div>
      <div className="container relative mt-12 py-10">
        <img
          src="/assets/logo-light.png"
          alt="adsil"
          className="w-60 mx-auto"
        />
        <div className="text-secondary text-center flex justify-center gap-6 sm:gap-28 flex-wrap mt-10 mb-10">
          <div className="text-left">
            <h3 className="font-semibold text-lg mb-4">{langWords.client}</h3>
            <ul>
              <li className="mb-2 hover:underline">
                <Link to="/">Questions fréquante?</Link>
              </li>
              <li className="mb-2 hover:underline">
                <Link to="/">Questions fréquante?</Link>
              </li>
            </ul>
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-lg mb-4">{langWords.partners}</h3>
            <ul>
              <li className="mb-2 hover:underline">
                <Link to="/">Questions fréquante?</Link>
              </li>
              <li className="mb-2 hover:underline">
                <Link to="/">C'est quoi DRIVER?</Link>
              </li>
            </ul>
          </div>
          <div className="text-center sm:text-left">
            <h3 className="font-semibold text-lg mb-4">
              {langWords.contactUs}
            </h3>
            <ul className="flex gap-5 sm:block">
              <li className="mb-2 hover:underline">
                <p>support@adsil.io</p>
              </li>
              <li className="mb-2 hover:underline">
                <p>0798779631</p>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h3 className="text-lg mb-4 text-center text-secondary">
            {langWords.followUs}
          </h3>
          <ul className="flex justify-center text-secondary gap-4 mb-6">
            <li>
              <a
                className="flex items-center space-x-2 group w-min"
                href="/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FaFacebook className="group-hover:text-third" />
                <span>facebook</span>
              </a>
            </li>
            <li>
              <a
                className="flex items-center space-x-2  group w-min"
                href="/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FaInstagram className="group-hover:text-third" />
                <span>instagram</span>
              </a>
            </li>
            <li>
              <a
                className="flex items-center space-x-2  group w-min"
                href="/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FaLinkedin className="group-hover:text-third" />
                <span>linkedin</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="text-secondary text-center">
          {langWords.footerRights} {new Date().getFullYear()} &copy;{" "}
          <span className="text-third font-bold">ADSIL</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
